{
  "types": {
    "topup": "Nạp tiền",
    "payment_debit": "Thanh toán điều trị",
    "payment_debit_reversal": "Hoàn tạm ứng về TK nạp trước",
    "refund": "Hoàn/rút TK nạp trước",
    "bonus_credit": "KM nạp tiền",
    "topup_reversal": "Hủy nạp tiền",
    "refund_reversal": "Hủy hoàn tiền"
  },
  "status": {
    "draft": "Nháp",
    "cancelled": "Đã hủy"
  },
  "dialogs": {
    "topUpTitle": "Nạp tiền vào TK nạp trước",
    "refundTitle": "Hoàn / rút tiền TK nạp trước",
    "cancelTopupTitle": "Hủy phiếu nạp tiền",
    "confirmCancelTopup": "Hủy phiếu này sẽ trừ lại số tiền đã nạp và tiền thưởng đi kèm, nếu số dư còn đủ. Phiếu vẫn được giữ lại.",
    "cancelRefundTitle": "Hủy phiếu hoàn tiền",
    "confirmCancelRefund": "Hủy phiếu này sẽ cộng lại tiền gốc đã hoàn và gỡ khoản chi khỏi sổ. Phiếu vẫn được giữ lại.",
    "deleteDraftTitle": "Xóa nháp nạp tiền",
    "deleteDraftMessage": "Nháp này chưa ghi vào TK nạp trước. Xóa thì không khôi phục được."
  },
  "placeholders": {
    "clinic": "Chọn chi nhánh",
    "paymentMethod": "Phương thức thanh toán",
    "topUpAmount": "Số tiền nạp phải lớn hơn 0",
    "refundAmount": "Số tiền hoàn phải lớn hơn 0",
    "referenceCode": "Nhập mã tham chiếu",
    "notes": "Nhập ghi chú",
    "cancelReason": "Nhập lý do hủy"
  },
  "fields": {
    "amount": "Số tiền",
    "paymentMethod": "Hình thức thanh toán",
    "notes": "Ghi chú",
    "reason": "Lý do",
    "type": "Loại",
    "date": "Ngày",
    "balanceAfter": "Số dư sau",
    "principal": "Gốc",
    "bonus": "Thưởng",
    "patient": "Bệnh nhân",
    "topUpAmount": "Số tiền nạp",
    "refundAmount": "Số tiền hoàn",
    "collectionMethod": "Phương thức thanh toán",
    "disbursementMethod": "Phương thức chi",
    "transactionDate": "Ngày giao dịch",
    "referenceCode": "Mã tham chiếu",
    "transactionCode": "Mã GD",
    "principalBonus": "Gốc / Thưởng",
    "method": "Phương thức",
    "cancelReason": "Lý do hủy"
  },
  "table": {
    "date": "Ngày giao dịch",
    "type": "Loại",
    "amount": "Số tiền",
    "balanceAfter": "Số dư sau",
    "notes": "Ghi chú",
    "empty": "Chưa có giao dịch TK nạp trước"
  },
  "actions": {
    "topUp": "Nạp tiền",
    "refund": "Hoàn/rút",
    "saveDraft": "Lưu nháp",
    "saveDraftOptions": "Thêm thao tác nạp tiền",
    "refundSaveDraftOptions": "Thêm thao tác hoàn tiền",
    "savingDraft": "Đang lưu...",
    "confirm": "Xác nhận",
    "confirmAndPrint": "Xác nhận và In",
    "confirming": "Đang xác nhận...",
    "cancel": "Hủy",
    "cancelTopup": "Hủy phiếu",
    "cancelling": "Đang hủy...",
    "editDraft": "Sửa",
    "deleteDraft": "Xóa",
    "processing": "Đang xử lý..."
  },
  "drafts": {
    "title": "Nháp chưa xác nhận",
    "refundTitle": "Nháp hoàn tiền"
  },
  "summary": {
    "balance": "Số dư TK nạp trước",
    "principal": "Tiền gốc",
    "bonus": "Tiền thưởng"
  },
  "validation": {
    "amountRequired": "Vui lòng nhập số tiền",
    "amountPositive": "Số tiền phải lớn hơn 0",
    "paymentMethodRequired": "Vui lòng chọn hình thức thanh toán",
    "reasonRequired": "Vui lòng nhập lý do",
    "topUpPositive": "Số tiền nạp phải lớn hơn 0",
    "topUpMax": "Số tiền nạp tối đa {{amount}}",
    "notesTooLong": "Ghi chú không được quá {{max}} ký tự",
    "cancelReasonRequired": "Vui lòng nhập lý do hủy",
    "cancelReasonTooLong": "Lý do hủy không được quá {{max}} ký tự",
    "refundPositive": "Số tiền hoàn phải lớn hơn 0",
    "refundMax": "Số tiền hoàn tối đa {{amount}}",
    "principalOnlyMax": "Chỉ hoàn được tiền gốc. Tối đa: {{amount}}"
  },
  "toasts": {
    "topUpSuccess": "Đã xác nhận nạp tiền",
    "topUpFailed": "Không xác nhận được nạp tiền",
    "draftSaved": "Đã lưu nháp",
    "draftSaveFailed": "Không lưu được nháp",
    "draftDeleted": "Đã xóa nháp",
    "draftDeleteFailed": "Không xóa được nháp",
    "cancelTopupSuccess": "Đã hủy phiếu nạp tiền",
    "cancelTopupFailed": "Không hủy được phiếu nạp tiền",
    "cancelInsufficient": "Số dư TK nạp trước không còn đủ để hủy phiếu này",
    "cancelRefundSuccess": "Đã hủy phiếu hoàn tiền",
    "cancelRefundFailed": "Không hủy được phiếu hoàn tiền",
    "refundSuccess": "Đã hoàn/rút tiền thành công",
    "refundFailed": "Hoàn/rút tiền thất bại",
    "loadFailed": "Không tải được giao dịch TK nạp trước",
    "topUpSuccessWithBonus": "Đã xác nhận nạp tiền (+{{amount}} thưởng)"
  },
  "promotion": {
    "applied": "Áp dụng KM \"{{name}}\": +{{amount}} tiền thưởng",
    "checking": "Đang kiểm tra khuyến mãi..."
  },
  "refundInfo": {
    "availableBalance": "Số dư khả dụng: {{amount}}",
    "refundablePrincipal": "Tiền gốc (có thể hoàn): {{amount}}",
    "nonRefundableBonus": "Tiền thưởng không hoàn: {{amount}}",
    "maxRefundable": "Có thể hoàn tối đa: {{amount}}"
  },
  "delta": {
    "principal": "Gốc {{amount}}",
    "bonus": "Thưởng {{amount}}",
    "amountSplit": "Thưởng {{bonus}} · Gốc {{principal}}"
  }
}
